/*
Searches for hurenkind .button_arrow
*/

(function () {
  const buttonArrowElements = document.querySelectorAll('.page-teaser__item .button__arrow');

  for (let i = 0; i < buttonArrowElements.length; i++) {
    if (buttonArrowElements[i].offsetLeft === 16) {
      buttonArrowElements[i].parentElement.style.paddingRight = '20px';
    }
  }
}());
